import { useRef, useState } from 'react';
import { publicMenuUrl, menuQrImage, menuQrFilename, downloadMenuQr } from '../menuSharing';

export default function MenuShare({ slug, published }) {
  const url = publicMenuUrl(slug);
  const input = useRef(null);
  const [message, setMessage] = useState('');
  const [generating, setGenerating] = useState(false);

  async function copy() {
    setMessage('');
    try {
      if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
      await navigator.clipboard.writeText(url);
      setMessage('Link copiato.');
    } catch {
      input.current?.focus();
      input.current?.select();
      setMessage('Copia automatica non disponibile: copia il link selezionato.');
    }
  }

  async function download() {
    setGenerating(true);
    setMessage('');
    try {
      const image = await menuQrImage(url);
      downloadMenuQr(image, menuQrFilename(slug));
      setMessage('Download del QR avviato (PNG).');
    } catch {
      setMessage('Non è stato possibile creare il QR. Riprova.');
    } finally {
      setGenerating(false);
    }
  }

  return <section className="owner-menu-share" aria-label="Condividi il menù">
    <h3>Condividi il menù</h3>
    {url ? <>
      <input ref={input} aria-label="Link pubblico del menù" readOnly value={url} onFocus={event => event.target.select()}/>
      <div className="guest-actions">
        <button type="button" className="button button-small button-ghost" onClick={copy}>Copia link</button>
        <button type="button" className="button button-small button-ghost" disabled={generating} onClick={download}>{generating ? 'Creo il QR…' : 'Scarica QR'}</button>
        {published && <a href={url} target="_blank" rel="noreferrer">Apri menù ↗</a>}
      </div>
      <p className="guest-muted">{published ? 'Il QR resta valido anche quando aggiorni il menù.' : 'Menù non pubblico: pubblicalo prima di condividere link o QR.'}</p>
    </> : <p className="guest-muted">Link del menù non disponibile. Ricarica la pagina.</p>}
    {message && <p role="status" className="owner-menu-share-status">{message}</p>}
  </section>;
}
